module.exports = {
    SITE_URL: 'https://developers.thoughtspot.com/docs/',
    DOC_REPO_NAME: '',
    DOC_NAV_PAGE_ID: 'nav',
    TS_HOST_PARAM: 'tshost',
    TS_ORIGIN_PARAM: 'origin',
    TS_APP_ROOT_PARAM: 'appRoot',
    TS_PAGE_ID_PARAM: 'pageid',
    NAV_PREFIX: 'navprefix',
    PREVIEW_PREFIX: 'previewPrefix',
    VISUAL_EMBED_SDK_PREFIX: 'visualEmbedSDKPrefix',
    NOT_FOUND_PAGE_ID: '404-error',
    HOME_PAGE_ID: 'introduction',
    NOT_FOUND_GO_HOME_PAGE_ID: 'introduction',
    TYPE_DOC_PREFIX: 'typedoc',
    DEFAULT_HOST: 'https://try-everywhere.thoughtspot.cloud',
    DEFAULT_PREVIEW_HOST: 'https://try-everywhere.thoughtspot.cloud/v2',
    DEFAULT_APP_ROOT: '/everywhere',
    IS_PUBLIC_SITE_OPEN: 'isPublicSiteOpen',
    TS_DEMO_LOGIN: '/callosum/v1/session/demo/login',
    TS_SESSION_TOKEN: '/prism/?op=GetSessionToken',
    TS_INFO: '/callosum/v1/session/info',
    TS_Version: 'Version',
    BUILD_ENVS: {
        PROD: 'PROD',
        DEV: 'DEV',
        STAGING: 'STAGING',
        PROD_VERSIONING: 'PROD_VERSIONING',
        LOCAL: 'LOCAL',
    },
    DEPLOY_ENVS: {
        RELEASE: 'release',
        DEV: 'dev',
    },
    VERSION_DROPDOWN: [
        {
            label: '9.3.0.cl',
            link: '9.3.0',
            subLabel: 'Cloud (Latest)',
        },

        {
            label: '9.0.1.sw',
            link: 'https://visual-embed-sdk-9-0.vercel.app/docs',
            subLabel: 'Software (Latest)',
        },
        {
            label: '8.8.1.sw',
            link: 'https://visual-embed-sdk-8-8.vercel.app/docs/',
            subLabel: 'Software',
        },
        {
            label: '8.4.1.sw',
            link: 'https://visual-embed-sdk-8-4.vercel.app/docs/',
            subLabel: 'Software',
        },
    ],
    CUSTOM_PAGE_ID: {
        API_PLAYGROUND: 'restV2-playground',
        VISUAL_EMBED_SDK: 'js-reference',
    },
    CLUSTER_TYPES: {
        PROD: 'PROD',
    },
};
